import React from 'react';
import PropTypes from 'prop-types';
import {Transition} from 'react-transition-group';

export default class FadeTransition extends React.PureComponent {
    static propTypes = {
        fadeIn: PropTypes.bool,
        duration: PropTypes.number.isRequired,
        children: PropTypes.node.isRequired
    };

    static defaultProps = {
        duration: 500,
        fadeIn: false
    };

    defaultStyle = {
        transition: `opacity ${this.props.duration}ms ease-in-out`,
        opacity: 0,
        pointerEvents: 'none'
    };

    transitionStyles = {
        entering: {opacity: this.props.fadeIn ? 0 : 1, pointerEvents: 'all'},
        entered: {opacity: 1, pointerEvents: 'all'}
    };

    renderChild = (state) => {
        let style = {
            ...this.defaultStyle,
            ...this.transitionStyles[state]
        };

        return (
            <div style={style} className="fade-transition">
                {this.props.children}
            </div>
        );
    }

    render () {
        return (
            <Transition {...this.props} timeout={this.props.duration}>
                {this.renderChild}
            </Transition>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/fade-transition.js